/* global Flickity */
export default class Slider {
	constructor(slider) {
		this.slider = slider;
		if (!this.slider) return;

		this.init();
	}

	init() {
		this.flickity = Flickity.data(this.slider);
		this.buttons = this.slider.closest('.room-category').querySelectorAll('.arrow-button');
		this.events();
	}

	events() {
		if (this.buttons) {
			this.buttons.forEach( btn => {
				btn.addEventListener('click', ev => {
					ev.preventDefault();
					if (btn.classList.contains('right-arrow')) {
						this.flickity.next(true, false);
					} else {
						this.flickity.previous(true, false);
					}
				});
			});
		}
	}
}
